module.exports = __webpack_public_path__ + "6e25c1db451dd3ac74227b1383474024.svg";